import { Pipe, PipeTransform } from '@angular/core';
import * as Models from '../_models';
import { flatGroup } from 'd3';

@Pipe({
    name: 'filtroNuevo', standalone: false
})

export class FiltroCursoNuevoPipe implements PipeTransform {
    transform(
        list: Models.CursoDto[],
        includeCursosN: boolean,
        includeSinHijos: boolean,
        parentOnly: boolean = false,
        parentSelect: boolean = false
    ): Models.CursoDto[] {
        if (!list) { return [] };
        if (!includeCursosN) { list = list.filter(curso => curso.nickName !== 'N') };
        if (!includeSinHijos) { list = list.filter(curso => curso.cursos.length > 0) };
        if (parentOnly) { list = list.filter(curso => curso.cursos.length > 0)
            .map(curso => { return { ...curso, nickName:curso.nombre, cursos: [] } }) };
        if (parentSelect) {
            // extraer cursos de cada elemento y armar un nuevo array
            let newList: Models.CursoDto[] = [];
            list.forEach(curso => {
                newList = [...newList, { ...curso, nickName: curso.nombre, cursos: [] }, ...curso.cursos];
            });
            list = newList;
        };
        return list;
    }
}
